import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot } from "vue"

import { computed, onBeforeUnmount, onMounted, watch } from "vue";
import { useDashboards } from "@/composables/dashboard";
import { useReports } from "@/composables/report";
import { useStreams } from "@/composables/stream";


export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardPreloader',
  emits: ["ready"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

let timeoutTimer: ReturnType<typeof setTimeout> | null = null;
let isReady = false;

const { isLoading: areDashboardsLoading } = useDashboards();
const { isLoading: areReportsLoading } = useReports();
const { isLoading: areStreamsLoading } = useStreams();

const isLoading = computed(
  () => areDashboardsLoading.value || areReportsLoading.value || areStreamsLoading.value,
);

const emitReady = () => {
  if (!isReady) {
    isReady = true;
    emit("ready");
  }
  if (timeoutTimer) {
    clearTimeout(timeoutTimer);
    timeoutTimer = null;
  }
};

const emitReadyIfFinishedLoading = () => {
  if (!isLoading.value) {
    emitReady();
  }
};

watch(isLoading, () => {
  emitReadyIfFinishedLoading();
});

onMounted(() => {
  emitReadyIfFinishedLoading();
  if (!isReady) {
    timeoutTimer = setTimeout(() => {
      emitReady();
    }, 200);
  }
});

onBeforeUnmount(() => {
  if (timeoutTimer) {
    clearTimeout(timeoutTimer);
    timeoutTimer = null;
  }
});

return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default")
}
}

})